import { useSearchParams } from 'react-router-dom';
import Button from 'components/Button';
import usePostData from 'hooks/usePostData';
import translating from './translate.json';

import './style.scss';
import { useEffect } from 'react';

const ConfirmPage = () => {
  const [searchParams] = useSearchParams();
  const { res, error, postData } = usePostData();

  const shippingNum = searchParams.get('ShippingNum');
  const selectedDate = searchParams.get('SelectedDate');
  const selectedTime = searchParams.get('SelectTimeSlot');
  const city = searchParams.get('City');
  const street = searchParams.get('Street');
  const phone = searchParams.get('Phone');
  const email = searchParams.get('Mail');
  const name = searchParams.get('Name');
  const ssn = searchParams.get('Ssn');
  const buildingNum = searchParams.get('BuildingNum');
  const addressComments = searchParams.get('AddressComments');
  const handleConfirm = () => {
    const clientProductId = sessionStorage.getItem('deliveryProductId');
    const productStageId = sessionStorage.getItem('deliveryProductStageId');
    sessionStorage.removeItem('deliveryProductStageId');
    sessionStorage.removeItem('deliveryProductId');
    postData(
      `client-product-stage/update_client_product_stage_Delivery/${productStageId}`,
      {
        productStageId: productStageId,
        clientProductId: clientProductId,
        deliveryDate: selectedDate,
        deliveryTimeSlot: selectedTime,
        deliveryId: shippingNum,
        deliveryResponce: 'string',
        City: city,
        Street: street,
        BuildingNum: buildingNum,
        Entrance: 'string',
        Floor: 'string',
        Zipcode: 'string',
        AddressComments: addressComments,
        Email: email,
        Phone: phone,
        Name: name,
        Ssn: ssn
      },
      'patch'
    );
  };

  const closeModal = () => {
    window.top.location.reload();
  };

  useEffect(() => {
    if (res) {
      if (res.delivery === 'Falied') alert(res.res);
      else if (res.affected === 1) alert('מועד הבדיקה תואם בהצלחה');
      else alert('failed');
      closeModal();
    }
  }, [res, error]);

  return (
    <div className="confirm-page">
      <div className="confirm-page-title">{translating.title}</div>
      <div className="confirm-page-content">{` ${translating.toDate} ${selectedDate} ${translating.toHour} ${selectedTime}`}</div>
      <div className="wrapper-buttons">
        <Button
          txt={translating.ok}
          variant="outlined"
          handleClick={handleConfirm}
        ></Button>
        <Button
          txt={translating.cancel}
          variant="outlined"
          handleClick={closeModal}
        ></Button>
      </div>
    </div>
  );
};

export default ConfirmPage;
